// extracted by mini-css-extract-plugin
export default {"noDashboardsContainer":"styles_noDashboardsContainer__eJ9AD"};